import { useCallback, useState } from "react"

export const usePreviewImageDialog = () => {
    const [selectedImage, setSelectedImage] = useState<string | null>(null)

    const openImageModal = useCallback((imageUrl: string) => setSelectedImage(imageUrl), [])
    const closeImageModal = useCallback(() => setSelectedImage(null), [])

    return { selectedImage, openImageModal, closeImageModal }
}
